import { CheckBoxCell } from '@med-fe/ui';
import moment from 'moment';

export const marketing_columns = [
  {
    title: 'Location number',
    dataIndex: 'locationNumber',
    key: 'action',
    width: 120,
    fixed: 'left',
  },
  {
    title: 'Location name',
    dataIndex: 'locationName',
    key: 'locationName',
    width: 250,
  },
  {
    title: 'branding',
    dataIndex: 'branding',
    key: 'branding',
    width: 120,
  },
  {
    title: 'Branding Type',
    dataIndex: 'brandingType',
    key: 'brandingType',
    width: 150,
  },
  {
    title: 'ZocDoc Patient Type',
    dataIndex: 'zocDocPatientType',
    key: 'zocDocPatientType',
    width: 190,
  },
  {
    title: 'Legacy Name',
    dataIndex: 'legacyName',
    key: 'legacyName',
    width: 180,
  },
  {
    title: 'media market',
    dataIndex: 'mediaMarket',
    key: 'mediaMarket',
    width: 220,
  },
  {
    title: 'msa',
    dataIndex: 'msa',
    key: 'msa',
    width: 200,
  },
  {
    title: 'top 5',
    dataIndex: 'top5zip',
    key: 'top5zip',
    width: 120,
  },
  {
    title: 'digital metro category',
    dataIndex: 'digitalMetroCategory',
    key: 'digitalMetroCategory',
    width: 150,
  },
  {
    title: 'Storefront Category',
    dataIndex: 'storefrontCategory',
    key: 'storefrontCategory',
    width: 150,
  },
  {
    title: 'Other Storefront Category',
    dataIndex: 'otherSfcComment',
    key: 'otherSfcComment',
    width: 150,
  },
  {
    title: 'Google Book Online Button Type',
    dataIndex: 'googleBookOnlineButtonType',
    key: 'googleBookOnlineButtonType',
    width: 180,
  },
  {
    title: 'ByPass Form',
    dataIndex: 'byPassForm',
    key: 'byPassForm',
    width: 120,
    render: (value: boolean) => <CheckBoxCell value={value} />,
  },
  {
    title: 'Practice Affiliation Email Send Date',
    dataIndex: 'practiceAffiliationEmailSendDate',
    key: 'practiceAffiliationEmailSendDate',
    width: 240,
    render: (value: string) => (value ? moment(value).format('YYYY-MM-DD') : ''),
  },
  {}, // empty column, workaround to have column width fixed
];
